import { gql } from "config/graphql";
import { ICase } from "config/types";
import { gqlQuery } from "store/apollo";

export interface ICasesResponse {
  data: {
    cases: ICase[];
  };
}

export const getCasesQuery = (): Promise<ICasesResponse> => {
  const query = gql`
    query Cases {
      cases {
        id
        result
        decision
        externalId
        source
        createdAt
      }
    }
  `;

  return gqlQuery<ICasesResponse["data"]>({ query });
};
